<template>
  <div class="card card-default mb-1">
    <div class="card-header">
      <h5 class="mb-0">
        <a
          class="text-inherit"
          data-toggle="collapse"
          :data-target="'#collapse' + num"
          aria-expanded="true"
          :aria-controls="'collapse' + num"
        >{{ title }}</a>
        <div class="px-2 mr-2 float-right badge badge-success text-thin" v-if="type==='INTERNAL'">{{ $t('badge.internal') }}</div>
        <div class="px-2 mr-2 float-right badge badge-info text-thin" v-if="type==='EXTERNAL'">{{ $t('badge.external') }}</div>
      </h5>
    </div>
    <div
      class="collapse"
      :id="'collapse' + num"
      :aria-labelledby="'heading' + num"
      data-parent="#accordion">
      <div class="card-body border-top">
        <div class="row">
          <div class="col-md-6">
            <p class="title">{{ $t('email.template.subject') }}</p>
            <div class="form-group row">
              <div class="col-md-10">
                <input
                  class="form-control"
                  type="text"
                  :placeholder="$t('email.template.subject')"
                  v-model="template.subject">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-8 col-md-12 col-sm-12">
            <div class="alert alert-info bg-info-light">
              <em class="fa fa-exclamation-circle fa-lg fa-fw"></em>
              <span>{{ $t('email.template.tags') }} {{ tags }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-8 col-md-12 col-sm-12">
            <div class="card card-default">
              <div class="card-body">
                <form action="#">
                  <p>{{ $t('email.template.content') }}</p>
                  <textarea class="mb-3 form-control" cols="3" rows="12" v-model="template.content"></textarea>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-md-12">
            <div class="float-right">
              <div class="form-row align-items-center">
                <div class="col-auto">
                  <select class="custom-select custom-select-sm" v-model="language" @change="update_data">
                    <option value="EST">{{ $t('email.template.language.est') }}</option>
                    <option value="RUS">{{ $t('email.template.language.rus') }}</option>
                    <option value="ENG">{{ $t('email.template.language.eng') }}</option>
                  </select>
                </div>
                <div class="col-auto">
                  <button class="btn btn-sm btn-success wd-xs" @click="update_template">{{ $t('button.edit') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import message from '@/message'
import {parseApiError} from '@/utils'

export default {
  methods: {
    update_data () {
      api.get(`/email_templates/?key=${this.api_key}&type=${this.type}&language=${this.language}`)
        .then(resp => {
          this.template = resp.data.results[0]
        })
    },
    get_data () {
      api.get(`/email_templates/?key=${this.api_key}&type=${this.type}&language=${this.language}`)
        .then(resp => {
          this.template = resp.data.results[0]
        })
    },
    update_template () {
      api.patch(`/email_templates/${this.template.id}/`, this.template)
        .then(() => {
          message.success(this.$i18n.t('message.success.template.update'))
        })
        .catch(error => {
          let errors = parseApiError(error, this.$i18n)
          if (error.response && error.response.status === 400) {
            this.errors = errors
          } else {
            message.error(errors)
          }
        })
    }
  },
  props: {
    num: String,
    title: String,
    tags: String,
    type: String,
    api_key: String
  },
  mounted () {
    this.get_data()
    this.$i18n.locale = this.$store.getters.language
  },
  data () {
    return {
      template: {},
      language: 'EST'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Emailtemplate.vue